var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    desktop: _vm.showTitleBar, 
    'setting-overlay': _vm.showOverlaySetter,
    'login-page': _vm.$route.name === 'login'
  },attrs:{"id":"app"},on:{"contextmenu":function($event){$event.preventDefault();return _vm.preventDefaultContextMenu.apply(null, arguments)}}},[_c('router-view'),_c('transition',{attrs:{"name":"viewer-fade"}},[(_vm.imgPreviewer.show)?_c('ImgPreviewer',{attrs:{"initialIndex":_vm.imgPreviewer.initialIndex,"urlList":_vm.imgPreviewer.urlList,"isLongImg":_vm.imgPreviewer.isLongImg},on:{"close":_vm.imgPreviewerClose}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }